module.exports = __webpack_public_path__ + "img/新月祈願_desk.36742548.svg";